import { Injectable } from '@angular/core';
import { environment } from './environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config = environment;

  getApiUrl() {
    return this.config.apiUrl;
  }

  isProduction() {
    return this.config.production;
  }

  getEnvironment() {
    return this.config.environment;
  }

  isLoggingEnabled() {
    return this.config.enableLogging;
  }

  getVersion() {
    return this.config.version;
  }
  getMicrosoftGraphConfig() {
  return this.config.microsoftGraph;
}
}
